module.exports = __webpack_public_path__ + "img/occupation_inf_1.323b0bbb.png";